module.exports = __webpack_public_path__ + "media/images/applicant/icon-arrow-left-yellow-fdf4669dccee6431aaabb2c7788a8d74.svg";